// Full list of Basker booking statuses, but only 'onSale' is considered bookable
const BOOKABLE_STATUSES = [
    // 'cancelled',
    // 'comingSoon',
    // 'offSale',
    'onSale',
    // 'soldOut',
    // 'waitlist',
];

const PERFORMANCE_TYPES = {
    public: 'Public Performance',
    family_workshop: 'Family Workshop',
    special:'Special Event',
    public_sensory: 'Public Sensory Friendly',

    school: 'School Performance',
    school_sensory: 'School Sensory Friendly',
    seasonal_workshop:'Seasonal Workshop',
    classroom_workshop: 'Classroom Workshop',
};

export function isBookable(perf) {
    if (BOOKABLE_STATUSES.includes(perf.bookingStatus)) {
        // Basker instance status override
        return true;
    }
    if (perf.booking.bookingLinkURL) {
        // Basker instance booking link override
        return true;
    }
    if (parseInt(perf.tessitura.availability, 10) > 0) {
        // Checking availability of Tessitura performance (null or undefined values are `NaN` so will not trigger)
        return true;
    }
    // Add other 3rd party systems (spektrix, etc.) as needed with additional conditions here
    return false;
}

/**
 *
 * @param {*} perf Performance instance
 * @returns {Boolean}
 */
export function isSchoolBooking(perf) {
    return [
        PERFORMANCE_TYPES.school,
        PERFORMANCE_TYPES.school_sensory,
        PERFORMANCE_TYPES.seasonal_workshop,
        PERFORMANCE_TYPES.classroom_workshop,
    ].includes(perf.attributes?.custom?.performance_type);
}
